import React from "react";
import { Stack, Typography } from "@mui/material";
import ChannelLegend from "./ChannelLegend";
import UsageOverTimeChart from "./UsageOverTimeChart";
import palette from "src/theme/palette";
import {
  buildUsageOverTimeFootnote,
  USAGE_OVER_TIME_EMPTY_SUBTITLE,
  USAGE_OVER_TIME_EMPTY_TITLE,
  USAGE_OVER_TIME_ERROR_TEXT,
  USAGE_OVER_TIME_MAX_MONTHS
} from "./SubscriptionTab.consts";

const UsageOverTime = ({ chartData, isLoading, isError, isEmpty }) => {
  if (isError) {
    return (
      <Stack alignItems="center" sx={{ py: 5 }} data-testid="usage-over-time-error">
        <Typography variant="body2" color="text.700">{USAGE_OVER_TIME_ERROR_TEXT}</Typography>
      </Stack>
    );
  }

  if (!isLoading && isEmpty) {
    return (
      <Stack alignItems="center" gap={1} sx={{ py: 5 }} data-testid="usage-over-time-empty">
        <Typography variant="body1" color="text.700">{USAGE_OVER_TIME_EMPTY_TITLE}</Typography>
        <Typography variant="body2" color="text.600" textAlign="center" maxWidth={320}>
          {USAGE_OVER_TIME_EMPTY_SUBTITLE}
        </Typography>
      </Stack>
    );
  }

  // Figma body: 32px top padding (CollapsibleSection gives 24) and 16px between chart and legend.
  return (
    <Stack gap={2} sx={{ pt: 1 }} data-testid="usage-over-time">
      <UsageOverTimeChart data={chartData} loading={isLoading} />
      {!isLoading && (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2" sx={{ color: palette.text[700], lineHeight: "22px" }} data-testid="usage-over-time-footnote">
            {buildUsageOverTimeFootnote(USAGE_OVER_TIME_MAX_MONTHS)}
          </Typography>
          <ChannelLegend testIdPrefix="usage-legend" />
        </Stack>
      )}
    </Stack>
  );
};

export default UsageOverTime;
